// You can write more code here

import {
  MINIGAME_CORRECT_COLOUR,
  MINIGAME_INCORRECT_COLOUR,
  MINIGAME_NEUTRAL_COLOUR,
} from '@/game/GameComponents/PhaserGame/Types/MinigameTypes';
import {
  animateBitmapColourTransition,
  DoPositiveFeedback,
  DoReinforcementFeedback,
  setBitmapColor,
  waitForMilliseconds,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';

/* START OF COMPILED CODE */

export default class SingleCharacterText extends Phaser.GameObjects.BitmapText {
  constructor(scene: Phaser.Scene, x?: number, y?: number, font?: string) {
    super(scene, x ?? 0, y ?? 0, font ?? 'Aronui');

    this.setOrigin(0.5, 0.5);
    this.tintTopLeft = 6896829;
    this.tintTopRight = 6896829;
    this.tintBottomLeft = 6896829;
    this.tintBottomRight = 6896829;
    this.text = 'A';
    this.fontSize = -64;

    /* START-USER-CTR-CODE */
    this.init();
    this.defaultColor = this.tintTopLeft;
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  defaultColor: number;
  initialAnimationTimeout?: NodeJS.Timeout;
  initialAnimationTween?: Phaser.Tweens.Tween;
  colourTransitionTween?: Phaser.Tweens.Tween;

  killInitialAnimation() {
    if (this.initialAnimationTimeout) {
      clearTimeout(this.initialAnimationTimeout);
    }
    if (this.initialAnimationTween) {
      this.initialAnimationTween.stop();
    }
    this.scale = 1;
    this.alpha = 1;
  }

  killColourTransition() {
    if (this.colourTransitionTween) {
      this.scene.tweens.killTweensOf(this);
      setBitmapColor(this, this.defaultColor);
    }
  }

  init() {
    this.scale = 1;
    this.alpha = 0;
    waitForMilliseconds(this.scene.time, 1).then(() => {
      this.alpha = 1;
      this.scale = 0;
      this.initialAnimationTween = this.scene.tweens.add({
        targets: this,
        // Initial pop-in with overshoot
        scale: 1,
        duration: 40,
        delay: 1,
        ease: 'Circ.easeOut',
      });
    });
  }

  setCharacter(character: string) {
    if (character.length > 1) {
      console.error('Character must be a single character');
      return this as SingleCharacterText;
    }
    this.text = character;
    return this as SingleCharacterText;
  }

  async doSuccessFeedback() {
    const feedbackDuration = 250;

    this.killColourTransition();
    this.colourTransitionTween = animateBitmapColourTransition(
      this,
      MINIGAME_CORRECT_COLOUR,
      this.defaultColor,
      feedbackDuration,
    );
    DoPositiveFeedback(this.scene, this, { feedbackDuration });

    await waitForMilliseconds(this.scene.time, feedbackDuration);

    setBitmapColor(this, this.defaultColor);
  }

  async doIncorrectFeedback() {
    const feedbackDuration = 250;

    this.killColourTransition();
    this.colourTransitionTween = animateBitmapColourTransition(
      this,
      MINIGAME_INCORRECT_COLOUR,
      this.defaultColor,
      feedbackDuration,
    );
    DoReinforcementFeedback(this.scene, this);

    await waitForMilliseconds(this.scene.time, feedbackDuration);

    setBitmapColor(this, this.defaultColor);
  }

  async doNeutralFeedback() {
    // this.killColourTransition();
    // this.colourTransitionTween = animateBitmapColourTransition(
    //   this,
    //   MINIGAME_NEUTRAL_COLOUR,
    //   250,
    //   true,
    // );
    setBitmapColor(this, MINIGAME_NEUTRAL_COLOUR);
  }

  async doFadeOutFeedback() {
    const feedbackDuration = 250;

    this.killColourTransition();
    this.colourTransitionTween = animateBitmapColourTransition(
      this,
      MINIGAME_NEUTRAL_COLOUR,
      this.defaultColor,
      feedbackDuration,
      false,
    );
    DoPositiveFeedback(this.scene, this, { feedbackDuration });

    await waitForMilliseconds(this.scene.time, feedbackDuration);

    // Fade out tween.
    this.scene.tweens.add({
      targets: this,
      alpha: 0,
      duration: feedbackDuration,
      ease: 'Cubic.easeOut',
    });
  }

  overrideTextStyle(textStyle: {
    font?: string;
    colour?: number;
    size?: number;
  }) {
    this.setFont(textStyle.font ?? this.font);
    this.setFontSize(textStyle.size ?? this.fontSize);
    setBitmapColor(this, textStyle.colour ?? this.tintTopLeft);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
